import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ExternalLinkIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_5218_11216)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.7999 0.200139C11.8628 0.262682 11.9133 0.337735 11.95 0.425295V0.433117C11.9819 0.511665 11.9996 0.597807 12 0.687978V4.8909C12 5.27325 11.6902 5.58304 11.3079 5.58304C10.9255 5.58304 10.6157 5.27325 10.6157 4.8909V2.35997L4.71994 8.25573C4.59444 8.38124 4.4214 8.45879 4.23002 8.45879C3.84726 8.45879 3.53704 8.14857 3.53704 7.76581C3.53704 7.57443 3.61459 7.40139 3.7401 7.27589L9.64003 1.38013H7.1091C6.72676 1.38013 6.41696 1.07033 6.41696 0.687978V0.687561C6.41946 0.307714 6.72842 0 7.1091 0H11.3204C11.4121 0.000416956 11.4997 0.0187631 11.5747 0.0500348L11.5793 0.0517026C11.6623 0.0867269 11.7373 0.137179 11.7999 0.200139Z",
        fill: "currentColor"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.76859 7.61363C8.76859 7.23128 9.07839 6.92148 9.46074 6.92148V6.92188L9.47742 6.92148C9.85976 6.92148 10.1696 7.23128 10.1696 7.61363V10.4197C10.1696 11.2924 9.46199 12 8.5893 12H1.57568C0.705073 11.9975 0 11.2912 0 10.4197V3.41863C0.00250174 2.54969 0.706741 1.84545 1.57609 1.84295H4.38638C4.76873 1.84295 5.07853 2.15275 5.07853 2.5351C5.07853 2.91745 4.76873 3.22725 4.38638 3.22725H1.57609C1.47019 3.22725 1.38429 3.31314 1.38429 3.41905V10.4239C1.38429 10.5298 1.47019 10.6157 1.57609 10.6157H8.57679C8.6827 10.6157 8.76859 10.5298 8.76859 10.4239V7.61363Z",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5218_11216",
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white"
        })
      })
    })]
  });
}
ExternalLinkIcon.displayName = 'ExternalLinkIcon';